<template>
  <div
    :class="
      browserSize.xs === true || browserSize.sm === true
        ? 'methods'
        : 'methods2'
    "
  >
    <v-row>
      <v-col>
        <img
          width="220"
          height="150"
          class="iconMargin"
          src="../assets/terapiaW.jpg"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        col-md-12
        class="infText text-center"
        v-if="browserSize.xs === true || browserSize.sm === true"
      >
        <div class="display-1 font-weight-black grey--text text-center">
          {{ title }}
        </div>
      </v-col>
      <v-col col-md-12 class="infText text-center" v-else>
        <div class="display-2 font-weight-black grey--text text-center">
          {{ title }}
        </div>
      </v-col>
    </v-row>

    <v-col class="col-11">
      <span class="aboutText">
        {{ opis1 }}
      </span>
    </v-col>

    <v-col class="col-11">
      <span class="aboutText">
        {{ opis2 }}
      </span>
    </v-col>
  </div>
</template>

<script>
export default {
  data() {
    return {
      title: "Terapia wzroku",

      opis1:
        "Narząd wzroku to nie tylko nasze oczy, ale cały systemu powięzi otulający i oplatający gałkę oczną i mięśnie oka. Istnieje silny związek pomiędzy naszym narządem wzroku a układem mięśniowo-szkieletowym człowieka. Wskutek ruchu gałek ocznych oraz poprzez napięcie powięzi i mięśni oka pojawiają się informacje o tym w różnych rejonach naszego ciała. Nadwyrężenie narządu wzroku może prowadzić do występowania objawów w postaci np. bólu głowy, migreny, odczucia ogólnego zmęczenia, zaburzeń postawy ciała. Nie bez znaczenia dla sprawności narządu wzroku jest zachowanie prawidłowego sposobu oddychania, jakości i sposobu odżywiania, relaksacji w szczególności mięśni szyi i karku oraz właściwa praca wątroby. Zatem, prawidłowe widzenie to sprawny narząd wzroku oraz harmonia wielu organów i poczucie bezpieczeństwa człowieka. ",

      opis2:
        "Terapia narządu wzroku obejmuje schorzenia powodujące zaburzenia lub utratę zdolności widzenia do których zaliczamy krótkowzroczność, nadwzroczność, jaskrę. Głównie koncentruje się na ocenie postawy ciała pacjenta i pracy układu nerwowego, na dążeniu do równowagi w napięciu mięśni mających wpływ na jakość widzenia oraz na stymulacji układu nerwowego w celu lepszego odżywienia nerwu wzrokowego.",
    };
  },
  computed: {
    browserSize() {
      return this.$vuetify.breakpoint;
    },
  },
};
</script>

<style lang="scss" scoped>
.methods {
  margin-top: 12vh;
}
.methods2 {
  margin-top: 4vh;
}
.v-application .grey--text {
  color: #414149 !important;
}
.infText {
  margin: auto;
}
.paragraph {
  font-weight: bold;
  margin-top: 10px;
  text-align: left;
  margin-left: 6vw;
  margin-right: 3vw;
}
.paragraph2 {
  text-align: left;
  margin-left: 7vw;
  margin-right: 3vw;
}
.textWhy {
  margin-top: 25px;
  text-align: center;
}
.textWhyPhone {
  margin-top: 25px;
  margin-bottom: 25px;
  text-align: justify;
  text-align-last: left;
}
.aboutText {
  text-align-last: left;
  display: flex;
  align-items: center;
  justify-content: center;
  text-indent: 1.5em;
}
.row {
  display: flex;
  flex-wrap: wrap;
  flex: 1 1 auto;
  margin: auto;
  max-height: 50%;
}
.col {
  text-align: justify;
  text-align-last: center;
}
.col-11 {
  flex: 0 0 91.666667%;
  max-width: 91.666667%;
  align-content: center;
  display: flex;
  margin: auto;
}
</style>